import React, { Component } from 'react';
import { CardBody, Card, Label, Col, Button, Row, Input,Dropdown, DropdownToggle, DropdownItem, DropdownMenu,  } from 'reactstrap'
import { connect } from 'react-redux';
import { Preloading } from '../../components/UI/Preloader/action';
import fileSaver from 'file-saver';
import moment from 'moment';
import {
    ewsReportWithFinancialRequest
} from './action';
import {
    displayErrorMessage, displaySuccessMessage,
} from '../../Corporate/my-portfolio/monitoring/charts/monitoring-util'

class EWSDataUpload extends Component {

    state = {
        ewsReportFile: null,
        ewsReportWithFinancialResponse: null,
        downloadReportDrowpdown: false,
        downloadReportDrowpdownId: -1,
        downloadReportDropdownDisable: true,
    };

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if (this.props.ewsReportWithFinancialResponse !== prevProps.ewsReportWithFinancialResponse) {
            this.props.preloading(false);
            if (this.props.ewsReportWithFinancialResponse.status === "SUCCESS") {
                let statusCode = this.props.ewsReportWithFinancialResponse.data['status'];
                if (statusCode === 200) {
                    const data = this.props.ewsReportWithFinancialResponse.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"EWS_Report_With_Financial_Data"}_${moment().format("DD_MMM_YYYY")}.xlsx`)
                } else if (statusCode === 204) {
                    displayErrorMessage("No data found!!");
                }
            } else if (this.props.ewsReportWithFinancialResponse.status === "FAILURE") {
                displayErrorMessage("Plesae try again later!!")
            }
        }
    }

    uploadEWSReport = (isPortfolio, e) => {
        e.preventDefault();
        this.props.ewsReportWithFinancialRequest({
            file: this.state.ewsReportFile,
            isPortfolio: isPortfolio,
        })
        this.props.preloading(true);
    }

    handleEWSReportUpload = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({
                ewsReportFile: file,
                downloadReportDropdownDisable: false,
            });
        } else {
            this.setState({
                ewsReportFile: undefined,
                downloadReportDropdownDisable: true,
            });
            e.target.value = null;
            displayErrorMessage("Please upload Excel File only !");
        }
    }

    downloadReportToggle = (dropdownId) => {
        this.setState((prevState) => ({
            downloadReportDrowpdownId: dropdownId,
            downloadReportDrowpdown: !prevState.downloadReportDrowpdown,
        }));
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">EWS Report - Financial Parameters</h4>
                </div>
                <Card>
                    <CardBody >
                        <Label>Get EWS Report With Financial Parameters</Label>
                        <Row style={{ paddingTop: "10px" }}>
                            <Col>
                                <Input
                                    id="upload-ews-report"
                                    type="file"
                                    onChange={(e) => this.handleEWSReportUpload(e)}
                                    className="btn position-relative"
                                    style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col>
                                {/* <Button
                                    disabled={!this.state.ewsReportFile}
                                    color="primary"
                                    style={{ width: '296px' }}
                                    onClick={e => this.uploadEWSReport(e)}>
                                    Upload EWS Report
                                </Button> */}
                                <Dropdown
                                    isOpen={this.state.downloadReportDrowpdown && this.state.downloadReportDrowpdownId == 0} 
                                    toggle={() => this.downloadReportToggle(0)}>
                                    <DropdownToggle 
                                        disabled={this.state.downloadReportDropdownDisable} 
                                        color="primary" 
                                        style={{ width: '260px' }}>
                                        Upload EWS Report  <i className="fa fa-caret-down"></i>
                                    </DropdownToggle>
                                    <DropdownMenu style={{ width: '260px' }}>
                                        <DropdownItem 
                                            name='portfolio' 
                                            onClick={e => this.uploadEWSReport(true,e)}>
                                            Portfolio
                                        </DropdownItem>
                                        <DropdownItem 
                                            name='non-portfolio' 
                                            onClick={e => this.uploadEWSReport(false,e)}>
                                            Non-Portfolio
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    ewsReportWithFinancialResponse: state.ews.ewsReportWithFinancialResponse,
})

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    ewsReportWithFinancialRequest: (data) => { dispatch(ewsReportWithFinancialRequest(data)) },
});


export default connect(mapStateToProps, mapDispatchToProps)(EWSDataUpload);